import { render, staticRenderFns } from "./LessonInfographic.vue?vue&type=template&id=5536e122&scoped=true&"
import script from "./LessonInfographic.vue?vue&type=script&lang=ts&"
export * from "./LessonInfographic.vue?vue&type=script&lang=ts&"
import style0 from "./LessonInfographic.vue?vue&type=style&index=0&id=5536e122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5536e122",
  null
  
)

export default component.exports